import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const maxLengthValidator = (maxLength: number, message: string): ValidatorFn =>
  (control: AbstractControl): ValidationErrors | null => control.value?.length > maxLength
    ? { maxLength: message }
    : null;

